import { render, staticRenderFns } from "./Avalanche.vue?vue&type=template&id=145cb9c5&scoped=true"
import script from "./Avalanche.vue?vue&type=script&lang=js"
export * from "./Avalanche.vue?vue&type=script&lang=js"
import style0 from "./Avalanche.vue?vue&type=style&index=0&id=145cb9c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145cb9c5",
  null
  
)

export default component.exports